"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _colors = _interopRequireDefault(require("../../../styles/colors"));

var _style = _interopRequireDefault(require("../../Icon/style"));

var _OrbitNetLabels = _interopRequireDefault(require("../../Labels/OrbitNetLabels"));

var _TooltipActions = _interopRequireDefault(require("../../TooltipActions/TooltipActions"));

var _useTooltipAction2 = _interopRequireDefault(require("../../../hooks/useTooltipAction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HeaderRow = function HeaderRow(_ref) {
  var headerIcon = _ref.headerIcon,
      titleItems = _ref.titleItems,
      actions = _ref.actions,
      showDetails = _ref.showDetails,
      onSwitch = _ref.onSwitch;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      mapLabels = _useState2[0],
      getMapLabels = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isHovered = _useState4[0],
      setIsHovered = _useState4[1];

  var _useTooltipAction = (0, _useTooltipAction2["default"])(),
      openTooltip = _useTooltipAction.openTooltip,
      showTooltip = _useTooltipAction.showTooltip;

  (0, _react.useEffect)(function () {
    var mapTitleItems = titleItems.map(function (titleItem, index) {
      return {
        id: index + 1,
        description: titleItem
      };
    });
    getMapLabels(mapTitleItems);
  }, [titleItems]);
  return /*#__PURE__*/_react["default"].createElement(_styles.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.HeaderRowContent, null, /*#__PURE__*/_react["default"].createElement(_styles.HeaderRowIcon, null, headerIcon), /*#__PURE__*/_react["default"].createElement(_styles.HeaderRowTitle, null, /*#__PURE__*/_react["default"].createElement(_OrbitNetLabels["default"], {
    opts: {
      label: 'más',
      singleTitle: true
    },
    labels: mapLabels,
    type: "multiple"
  })), /*#__PURE__*/_react["default"].createElement(_styles.HeaderRowOptions, null, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    glyph: "more_vert",
    size: 24,
    color: _colors["default"].white.primary,
    onClick: openTooltip
  }), showTooltip && /*#__PURE__*/_react["default"].createElement(_TooltipActions["default"], {
    top: "1.6rem",
    right: "0",
    actions: actions
  }))), /*#__PURE__*/_react["default"].createElement(_styles.HeaderRowCaret, {
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    glyph: "arrow_down",
    size: isHovered ? 40 : 36,
    color: _colors["default"].indigo.accent1,
    active: showDetails,
    onClick: function onClick() {
      return onSwitch();
    }
  })));
};

HeaderRow.propTypes = {
  headerIcon: _propTypes["default"].any,
  titleItems: _propTypes["default"].arrayOf(_propTypes["default"].string),
  showDetails: _propTypes["default"].bool,
  onSwitch: _propTypes["default"].func,
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    description: _propTypes["default"].string.isRequired,
    action: _propTypes["default"].func
  }))
};
HeaderRow.defaultProps = {
  headerIcon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
  titleItems: [],
  actions: [],
  showDetails: false,
  onSwitch: function onSwitch() {}
};
var _default = HeaderRow;
exports["default"] = _default;